import { Alert, Button, Card, Modal, Typography } from 'antd'
import { getCleanupErrorMessage, getCleanupResultMessage } from './orphanedRouteEventsModel'
import { useCleanupOrphanedRouteEventsMutation } from './orphanedRouteEventsQueries'

const { Paragraph } = Typography

const OrphanedRouteEventsSection = () => {
  const mutation = useCleanupOrphanedRouteEventsMutation()

  const handleCleanup = () => {
    Modal.confirm({
      title: 'Clean up orphaned route events?',
      okText: 'Clean up',
      cancelText: 'Cancel',
      okButtonProps: { danger: true },
      width: 540,
      content: (
        <Paragraph style={{ marginBottom: 0 }}>
          This soft-deletes all future route calendar events whose job has been removed from the
          route, across all tenants. The cleanup is idempotent — running it again reports zero.
        </Paragraph>
      ),
      onOk: () => {
        mutation.mutate()
      },
    })
  }

  return (
    <Card title="Clean Up Orphaned Route Events" style={{ maxWidth: 760 }}>
      <Paragraph type="secondary">
        When a job is removed from a planned route, its already-generated future calendar events can
        be left behind on the schedule with no way to remove them. This cleans up those orphaned
        events across all tenants.
      </Paragraph>
      <Button type="primary" onClick={handleCleanup} loading={mutation.isLoading}>
        Clean up orphaned route events
      </Button>

      {(mutation.isSuccess || mutation.isError) && (
        <div style={{ marginTop: 24 }}>
          {mutation.isSuccess && (
            <Alert
              type="success"
              showIcon
              message="Cleanup complete"
              description={getCleanupResultMessage(mutation.data?.deletedCount ?? 0)}
            />
          )}
          {mutation.isError && (
            <Alert
              type="error"
              showIcon
              message="Cleanup failed"
              description={getCleanupErrorMessage(mutation.error)}
            />
          )}
        </div>
      )}
    </Card>
  )
}

export default OrphanedRouteEventsSection
